export enum OpcionsMenu {
    a = "a",
    accesscontrol = "accesscontrol",
    accesscontrolsetting = "accesscontrolsetting",
    accesscontrolstatus = "accesscontrolstatus",
    activeroute = "activeroute",
    activeroutes = "activeroutes",
    activeslots = "activeslots",
    activity = "activity",
    address = "address",
    addressimporter = "addressimporter",
    addressstrongaddress = "addressstrongaddress",
    alarmdefinition = "alarmdefinition",
    ambit = "ambit",
    b = "b",
    backOfficeIntegration = "backOfficeIntegration",
    bannedphone = "bannedphone",
    billing = "billing",
    billtype = "billtype",
    booking = "booking",
    bookingroutes = "bookingroutes",
    burguer = "burguer",
    c = "c",
    carrier = "carrier",
    chat = "chat",
    clientpreferent = "clientpreferent",
    clientprovider = "clientprovider",
    command = "command",
    CustomSetting = "CustomSetting",
    CustomTable = "CustomTable",
    d = "d",
    dailydocks = "dailydocks",
    dailyslots = "dailyslots",
    dataandparameters = "dataandparameters",
    dataset = "dataset",
    definitionform = "definitionform",
    delaymenu = "delaymenu",
    delegatecreate = "delegatecreate",
    delegatelist = "delegatelist",
    delegates = "delegates",
    deliverycommitment = "deliverycommitment",
    device = "device",
    documentaryreviewroutes = "documentaryreviewroutes",
    documentcustomexternalloadlog = "documentcustomexternalloadlog",
    dropout = "dropout",
    e = "e",
    festives = "festives",
    finalcustomer = "finalcustomer",
    forcedlink = "forcedlink",
    formerbooking = "formerbooking",
    formquestion = "formquestion",
    freightforwarder = "freightforwarder",
    gate = "gate",
    healthcertifier = "healthcertifier",
    home = "home",
    inbounds = "inbounds",
    inboundscreate = "inboundscreate",
    inboundslist = "inboundslist",
    inspector = "inspector",
    internal = "internal",
    international = "international",
    journeytable = "journeytable",
    link = "link",
    linkcompany = "linkcompany",
    linkdriver = "linkdriver",
    lite = "lite",
    loadconsole = "loadconsole",
    loadconsolesetting = "loadconsolesetting",
    logisticoperator = "logisticoperator",
    managementmodel = "managementmodel",
    managment = "managment",
    maritimeagency = "maritimeagency",
    myposition = "myposition",
    nonacceptances = "nonacceptances",
    nonacceptancescreate = "nonacceptancescreate",
    nonacceptanceslist = "nonacceptanceslist",
    none = "none",
    notificationtopicschemasystem = "notificationtopicschemasystem",
    operation = "operation",
    operationsmenu = "operationsmenu",
    operationstatistics = "operationstatistics",
    outbounds = "outbounds",
    outboundscreate = "outboundscreate",
    outboundslist = "outboundslist",
    panel = "panel",
    panels = "panels",
    panelsetting = "panelsetting",
    panelstateroutes = "panelstateroutes",
    partner = "partner",
    partnerall = "partnerall",
    partnerassignmentbyaddress = "partnerassignmentbyaddress",
    partnerimporter = "partnerimporter",
    partnernotification = "partnernotification",
    permissiongroup = "permissiongroup",
    phasetimestable = "phasetimestable",
    plate = "plate",
    plateannotation = "plateannotation",
    platetypology = "platetypology",
    portaddress = "portaddress",
    products = "products",
    provider = "provider",
    returns = "returns",
    returnscreate = "returnscreate",
    returnslist = "returnslist",
    reverselogistics = "reverselogistics",
    reverselogisticscreate = "reverselogisticscreate",
    reverselogisticslist = "reverselogisticslist",
    route = "route",
    routegroupimporter = "routegroupimporter",
    routeimporter = "routeimporter",
    routeplanned = "routeplanned",
    routepropertydefinition = "routepropertydefinition",
    routerealized = "routerealized",
    scope = "scope",
    screensandforms = "screensandforms",
    securityandnotifications = "securityandnotifications",
    settings = "settings",
    shipment = "shipment",
    shipper = "shipper",
    slotchangereason = "slotchangereason",
    statistics = "statistics",
    statisticsaccesscontrolbook = "statisticsaccesscontrolbook",
    statisticsaccesscontrollog = "statisticsaccesscontrollog",
    statisticsbookingslots = "statisticsbookingslots",
    statisticsbookingslotswithmemory = "statisticsbookingslotswithmemory",
    statisticsdelivery = "statisticsdelivery",
    statisticsdeliverycarrier = "statisticsdeliverycarrier",
    statisticsdeliveryclient = "statisticsdeliveryclient",
    statisticsdeliveryexpeditions = "statisticsdeliveryexpeditions",
    statisticsdeliverymenu = "statisticsdeliverymenu",
    statisticsdeliveryprovider = "statisticsdeliveryprovider",
    statisticsexternalrouteplanification = "statisticsexternalrouteplanification",
    statisticsgatesmenu = "statisticsgatesmenu",
    statisticsinternationalbookingslots = "statisticsinternationalbookingslots",
    statisticsinternationalcontainercontinouscontrol = "statisticsinternationalcontainercontinouscontrol",
    statisticsinternationalcontainercontrol = "statisticsinternationalcontainercontrol",
    statisticsinternationalcontrol = "statisticsinternationalcontrol",
    statisticsinternationalcontrolcontinuous = "statisticsinternationalcontrolcontinuous",
    statisticsinternationalloadscontainer = "statisticsinternationalloadscontainer",
    statisticsinternationalmenu = "statisticsinternationalmenu",
    statisticsinternationalplanification = "statisticsinternationalplanification",
    statisticsinternationalroutesdone = "statisticsinternationalroutesdone",
    statisticsinternationalroutesdonecontinuous = "statisticsinternationalroutesdonecontinuous",
    statisticsloadbycarrier = "statisticsloadbycarrier",
    statisticsloadbyclientpreferent = "statisticsloadbyclientpreferent",
    statisticsloadbydriver = "statisticsloadbydriver",
    statisticsloadbyfinalcostumer = "statisticsloadbyfinalcostumer",
    statisticsloadbyhearthcertifier = "statisticsloadbyhearthcertifier",
    statisticsloadbyinspector = "statisticsloadbyinspector",
    statisticsloadbylogisticoperator = "statisticsloadbylogisticoperator",
    statisticsloadbyprovider = "statisticsloadbyprovider",
    statisticsloadbyshipper = "statisticsloadbyshipper",
    statisticslogistics = "statisticslogistics",
    statisticslogisticsCargoByDockList = "statisticslogisticsCargoByDockList",
    statisticslogisticsCargoInboundByDockList = "statisticslogisticsCargoInboundByDockList",
    statisticslogisticsCargoInboundList = "statisticslogisticsCargoInboundList",
    statisticslogisticsCargoList = "statisticslogisticsCargoList",
    statisticslogisticsCargoOutboundByDockList = "statisticslogisticsCargoOutboundByDockList",
    statisticslogisticsCargoOutboundList = "statisticslogisticsCargoOutboundList",
    statisticsmenu = "statisticsmenu",
    statisticspartnerbypermissions = "statisticspartnerbypermissions",
    statisticspartnersmenu = "statisticspartnersmenu",
    statisticsplatecharacteristics = "statisticsplatecharacteristics",
    statisticsplatemenu = "statisticsplatemenu",
    statisticsroutesinternationalloadlist = "statisticsroutesinternationalloadlist",
    statisticsroutesinternationalmenu = "statisticsroutesinternationalmenu",
    statisticsroutesmenu = "statisticsroutesmenu",
    statisticsroutesnobooking = "statisticsroutesnobooking",
    statisticsroutesnoslot = "statisticsroutesnoslot",
    statisticsslots = "statisticsslots",
    statisticsslotsanalysisbyoccupation = "statisticsslotsanalysisbyoccupation",
    statisticsslotsbycharacteristics = "statisticsslotsbycharacteristics",
    statisticsslotsbypartnercarrier = "statisticsslotsbypartnercarrier",
    statisticsslotsbypartnerclientpreferent = "statisticsslotsbypartnerclientpreferent",
    statisticsslotsbypartnerdriver = "statisticsslotsbypartnerdriver",
    statisticsslotsbypartnerfinalcustomer = "statisticsslotsbypartnerfinalcustomer",
    statisticsslotsbypartnerhearthcertifier = "statisticsslotsbypartnerhearthcertifier",
    statisticsslotsbypartnerinspector = "statisticsslotsbypartnerinspector",
    statisticsslotsbypartnerlogisticoperator = "statisticsslotsbypartnerlogisticoperator",
    statisticsslotsbypartnerprovider = "statisticsslotsbypartnerprovider",
    statisticsslotsbypartnershipper = "statisticsslotsbypartnershipper",
    statisticsslotsbytags = "statisticsslotsbytags",
    statisticsslotschangereason = "statisticsslotschangereason",
    statisticsslotsexternalcontrol = "statisticsslotsexternalcontrol",
    statisticsslotsexternalcontrolcontinuos = "statisticsslotsexternalcontrolcontinuos",
    statisticsslotskpi = "statisticsslotskpi",
    statisticsslotsmenu = "statisticsslotsmenu",
    statisticsslotsmenuexternal = "statisticsslotsmenuexternal",
    statisticsslotsmovements = "statisticsslotsmovements",
    statisticsslotsplanificationbydate = "statisticsslotsplanificationbydate",
    statisticsslotsplanificationbydock = "statisticsslotsplanificationbydock",
    statisticsstaytime = "statisticsstaytime",
    statisticstelemetrybyplate = "statisticstelemetrybyplate",
    statisticstelemetrybyroute = "statisticstelemetrybyroute",
    statisticstelemetrybyshipment = "statisticstelemetrybyshipment",
    statisticstelemetrymenu = "statisticstelemetrymenu",
    statustable = "statustable",
    styles = "styles",
    supervision = "supervision",
    system = "system",
    tag = "tag",
    telemetryactualtemperatures = "telemetryactualtemperatures",
    telemetryactualtemperaturescontinuos = "telemetryactualtemperaturescontinuos",
    telemetryshipment = "telemetryshipment",
    tenantautomations = "tenantautomations",
    tenantcredential = "tenantcredential",
    tenantinfo = "tenantinfo",
    tenantresource = "tenantresource",
    tenantsetting = "tenantsetting",
    tenanttask = "tenanttask",
    tenantwarning = "tenantwarning",
    test = "test",
    testdatatypes = "testdatatypes",
    testnotificationspush = "testnotificationspush",
    totem = "totem",
    totems = "totems",
    totemsetting = "totemsetting",
    trucking = "trucking",
    typology = "typology",
    user = "user",
    userdata = "userdata",
}
